<div class="cov-dropdown" [ngClass]="{ mobile: isMobile }">
  <div class="input" [class]="{ open: selectedDropDownName === formPropertyName }" (click)="displayField(formPropertyName)">
    <div class="flex">
      <div class="title ml-10 mr-5">
        @for (word of splitWords(title); track word; let i = $index) {
          <span [class]="'word-' + (i + 1)">{{ word }}</span>
        }
      </div>
      <span class="selected-amount">({{ selectedItems || selectedAmount }})</span>
    </div>
    <fa-icon class="ml-15" [class]="{ flip: selectedDropDownName === formPropertyName }" icon="angle-down" />
  </div>

  @if (selectedDropDownName === formPropertyName) {
    <div class="options-container">
      <div class="options" [ngClass]="formPropertyName" (clickOutside)="closeDropdown()">
        @for (group of groupedOptions; track group; let groupIdx = $index) {
          <div [class]="{ 'nested-group': groupedOptions.length > 1 }">
            @if (group.subTitle) {
              <span class="sub-title ml-10">{{ group?.subTitle }}</span>
            }
            @for (opt of group?.options; track opt; let optIdx = $index) {
              <div>
                <div class="option ml-5 mr-5" (click)="selected(opt, groupIdx, optIdx)" [class]="{ selected: opt?.selected }">
                  <input type="checkbox" [checked]="opt?.selected" class="ml-5 mr-10" />
                  <span>{{ opt?.label }}</span>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
